import {
  SETTINGS_LOAD_REQUEST,
  SETTINGS_LOAD_SUCCESS,
  SETTINGS_LOAD_FAILURE
} from '../types/settings-types';

const initialState = {
  loading: false,
  error: null,
  settings: null
};

function settings(state = initialState, action: any = null) {
  switch (action.type) {
    case SETTINGS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case SETTINGS_LOAD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case SETTINGS_LOAD_SUCCESS:
      return {
        ...state,
        settings: action.payload,
        loading: false,
        error: null
      };

    default:
      return state;
  }
}

export default settings;
